import { Controller } from "@hotwired/stimulus"
import { fetchStream } from "../lib/stream_fetch"

// The first-save card's phone button. beforeinstallprompt and appinstalled
// fire once per document, and Turbo keeps the document across visits, so
// they are captured here for the document's lifetime; each card instance
// reads the cached state when it connects and subscribes to later changes.
const state = { deferred: null, installed: false, retired: false, listeners: new Set() }

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault()
  state.deferred = event
  state.listeners.forEach((listener) => listener())
})
window.addEventListener("appinstalled", () => {
  state.installed = true
  state.listeners.forEach((listener) => listener())
})

export default class extends Controller {
  static targets = ["install"]
  static values = { url: String }

  connect() {
    this.onChange = () => this.#sync()
    state.listeners.add(this.onChange)
    this.#sync()
  }

  disconnect() {
    state.listeners.delete(this.onChange)
  }

  async prompt() {
    const deferred = state.deferred
    if (!deferred) return
    state.deferred = null
    await deferred.prompt()
    const { outcome } = await deferred.userChoice
    if (outcome === "accepted") this.#retire()
  }

  #sync() {
    // A visit issued before the retire renders the card again: Turbo shows
    // the cached Home as a preview while the real response is in flight, and
    // a tap on the preview's card beats a response rendered with it (#3633)
    if (state.retired) {
      this.element.remove()
      return
    }

    const standalone = window.matchMedia("(display-mode: standalone)").matches || navigator.standalone
    if (state.installed || standalone) {
      this.#retire()
      return
    }
    this.installTarget.hidden = !state.deferred
  }

  async #retire() {
    if (this.retired) return
    this.retired = true
    const response = await fetchStream(this.urlValue, { method: "DELETE" })
    if (!response?.ok) return

    state.retired = true
    window.Turbo.renderStreamMessage(await response.text())
  }
}
